
import Vue from "vue";
import store from "@/store";

export default Vue.extend({
  name: "AuthLayout",
  props: {
    title: {
      type: String,
      required: true,
      default: "",
    },
  },
  methods: {
    switchTheme(): void {
      store.dispatch("app/switchTheme", {
        theme: null,
        component: this,
      });
    },
  },
  computed: {
    themeModeIcon(): string {
      return store.state.app.theme === "light"
        ? "mdi-weather-night"
        : "mdi-weather-sunny";
    },
  },
});
